import { keepPreviousData, useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { useMe } from '../../../organisation/useMe';
import { caseTransactionInternalApi } from '../../../apis';
import { FindCaseTransactionsPageRequest } from '../../../api-internal';

export const CASE_TRANSACTIONS_QUERY_KEY = 'caseTransactions';

export const useQueryCaseTransactionsPage = ({
  handle,
  page,
  size,
  query,
  orderBy,
  direction,
}: FindCaseTransactionsPageRequest) => {
  const { currentOrganisation } = useMe();

  return useQuery({
    queryKey: [
      CASE_TRANSACTIONS_QUERY_KEY,
      'page',
      handle,
      page,
      size,
      query,
      orderBy,
      direction,
      currentOrganisation?.id,
    ],
    queryFn: async () => {
      return await caseTransactionInternalApi.findCaseTransactionsPage({
        handle,
        page,
        size,
        query,
        orderBy,
        direction,
      });
    },
    placeholderData: keepPreviousData,
    enabled: !!currentOrganisation?.id && !!handle,
  });
};

export const useAttachCaseTransactions = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ handle, externalIds }: { handle: string; externalIds: string[] }) => {
      return caseTransactionInternalApi.attachCaseTransactions({
        handle,
        internalApiAttachCaseTransactionsRequest: { externalIds },
      });
    },
    onSuccess: (_data, { handle }) => {
      queryClient.invalidateQueries({ queryKey: [CASE_TRANSACTIONS_QUERY_KEY, 'page', handle] });
    },
  });
};

export const useDetachCaseTransactions = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ handle, externalIds }: { handle: string; externalIds: string[] }) => {
      return caseTransactionInternalApi.detachCaseTransactions({
        handle,
        internalApiDetachCaseTransactionsRequest: { externalIds },
      });
    },
    onSuccess: (_data, { handle }) => {
      queryClient.invalidateQueries({ queryKey: [CASE_TRANSACTIONS_QUERY_KEY, 'page', handle] });
    },
  });
};
